import { render, staticRenderFns } from "./BidangPengurusEdit.vue?vue&type=template&id=3f495ed8&scoped=true"
import script from "./BidangPengurusEdit.vue?vue&type=script&lang=js"
export * from "./BidangPengurusEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f495ed8",
  null
  
)

export default component.exports